import { usePatient } from '@/contexts/PatientContext';
import { Select, rem } from '@mantine/core';
import { IconUser } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { Group, Text, ActionIcon } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import NewPatientButton from '../NewPatientButton/NewPatientButton';

import { useDisclosure, useMediaQuery } from '@mantine/hooks';

export function PatientSelect({ withLabel = true }) {
  const { setPatient, patient, patients, reloadPatients } = usePatient();
  const navigate = useNavigate();
  const [opened, { open, close }] = useDisclosure(false);

  const { t } = useTranslation();

  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <div style={{ width: isMobile ? '90%' : '100%' }}>
      {/* Contenedor del título y el botón */}
      <NewPatientButton
        opened={opened}
        onFinish={() => {
          reloadPatients();
          close();
        }}
        onClose={() => close()}
      />
      <Group justify="space-between" mb="xs">
        <Text fw={500}>{t('patient_select.patient')}</Text>
        <ActionIcon variant="light" color="blue" onClick={open}>
          <IconPlus style={{ width: rem(16), height: rem(16) }} />
        </ActionIcon>
      </Group>

      {/* Select con el listado de pacientes */}
      <Select
        withCheckIcon={false}
        allowDeselect={false}
        leftSection={<IconUser style={{ width: rem(16), height: rem(16) }} />}
        comboboxProps={{ transitionProps: { transition: 'pop', duration: 200 } }}
        onChange={(newPatient) => {
          setPatient(patients?.find((patient) => '' + patient.id === newPatient)!);
          navigate('/patients/' + newPatient + '/dashboard');
        }}
        data={patients?.map(({ id, name }) => ({ value: '' + id, label: name }))}
        value={patient == null ? undefined : '' + patient.id}
        searchable
      />
    </div>
  );
}
